import React, { useEffect, useRef, useState } from 'react';
import './header.css';

const Header = () => {
  /* TOGGLE MENU!!! */
  const [Toggle, showMenu] = useState(false);
  const [activeNav, setActiveNav] = useState('');
  const headerRef = useRef(null);
  const menuRef = useRef(null);

  const handleNavClick = (event, hash) => {
    event.preventDefault();

    const target = document.querySelector(hash);
    if (!target) return;

    setActiveNav(hash);
    showMenu(false);

    // Wait one frame so layout reflects closed mobile menu, then scroll with offset.
    requestAnimationFrame(() => {
      if (hash === '#home' && window.innerWidth <= 768) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        window.history.replaceState(null, '', hash);
        return;
      }

      const navHeight = headerRef.current?.querySelector('.nav')?.offsetHeight || 0;
      const extraSpacing = window.innerWidth <= 768 ? 26 : 16;
      const targetTop = target.getBoundingClientRect().top + window.scrollY - navHeight - extraSpacing;

      window.scrollTo({ top: Math.max(targetTop, 0), behavior: 'smooth' });
      window.history.replaceState(null, '', hash);
    });
  };

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('.header');
      if (!header) return;

      if (window.scrollY >= 80) header.classList.add('scroll-header');
      else header.classList.remove('scroll-header');
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const updateMobileOffset = () => {
      if (window.innerWidth > 768) {
        document.documentElement.style.removeProperty('--mobile-header-offset');
        return;
      }

      const navHeight = headerRef.current?.querySelector('.nav')?.offsetHeight || 0;
      const menuHeight = Toggle ? (menuRef.current?.scrollHeight || 0) : 0;
      const totalOffset = navHeight + menuHeight;
      document.documentElement.style.setProperty('--mobile-header-offset', `${totalOffset}px`);
    };

    updateMobileOffset();
    window.addEventListener('resize', updateMobileOffset);

    return () => {
      window.removeEventListener('resize', updateMobileOffset);
      document.documentElement.style.removeProperty('--mobile-header-offset');
    };
  }, [Toggle]);
  
  return (
    <header className='header' ref={headerRef}>
      <nav className='nav container'> 
        <a href='index.html' className="nav__logo">MattGaviria.</a>

        <div className={Toggle ? "nav__menu show-menu" : "nav__menu"} ref={menuRef}>
          <ul className='nav__list grid'>

            <li className='nav__item'>
              <a href="#home" 
                onClick={(event) => handleNavClick(event, '#home')} 
                className={activeNav === '#home' ? 'nav__link active-link' : 'nav__link'}>
                <i className="uil uil-estate nav__icon"></i> Home
              </a> 
            </li>

            <li className='nav__item'>
              <a href="#education" 
                onClick={(event) => handleNavClick(event, '#education')} 
                className={activeNav === '#education' ? 'nav__link active-link' : 'nav__link'}>
                <i className="uil uil-graduation-cap nav__icon"></i> Education
              </a> 
            </li>

            <li className='nav__item'>
              <a href="#skills" 
                onClick={(event) => handleNavClick(event, '#skills')} 
                className={activeNav === '#skills' ? 'nav__link active-link' : 'nav__link'}>
                <i className="uil uil-file-alt nav__icon"></i> Skills
              </a> 
            </li>

            <li className='nav__item'>
              <a href="#portfolio" 
                onClick={(event) => handleNavClick(event, '#portfolio')} 
                className={activeNav === '#portfolio' ? 'nav__link active-link' : 'nav__link'}>
                <i className="uil uil-scenery nav__icon"></i> Portfolio
              </a> 
            </li>
            
            <li className='nav__item'>
              <a href="#contact" 
                onClick={(event) => handleNavClick(event, '#contact')} 
                className={activeNav === '#contact' ? 'nav__link active-link' : 'nav__link'}>
                <i className="uil uil-message nav__icon"></i> Contact
              </a> 
            </li>

          </ul>

          <i className="uil uil-times nav__close" onClick={() => showMenu(!Toggle)}></i>
        </div>
        
        <div className='nav__toggle' onClick={() => showMenu(!Toggle)}>
          <i className="fa-solid fa-bars"></i>
        </div>

      </nav>
    </header>
  );
};

export default Header;
